import { useMemo, useState } from "react";
import TitlePage from "../../../../components/TitlePage";
import { Row, Col, Button } from "react-bootstrap";
import { ConsultaTotvsEmpresaIndividual } from "../../../../../backend/ConsultaTotvsEmpresa";
import ResponsiveDataTable from "../../../../components/DataTable";
import LoadingSpinner from "../../../../components/LoadinSpinner";
import InputGeral from "../../../../components/InputGeral/Index";

import SelectEmpresa from "../../../../components/Select/Empresa";
import SelectCentroCusto from "../../../../components/Select/CentroCusto";
import { formatarComoDecimal, formatarComoMoeda, optionsStatusPC, optionsStatusSC } from "../../../../contents/VariaveisGlobais";
import { format, startOfMonth, startOfYear } from "date-fns";
import BuscaProduto from "../../../../components/BuscaProduto";
import { CelBreak, CelBreak25 } from "../../../../components/GridCell/styles";
import { handleData, handlePrecoUnitario, handleValorTotal } from "../../../../components/GridCell/Preco";
import ExportarExcel from "../../../../components/ExportarExcel";
import { handlePrioridadeSCColumn, handleStatusSC } from "../../../../components/GridCell/Solicitacao";
import SelectFixo from "../../../../components/SelectFixo";

function VendorList(){
    // define a exibição do Loading
    const currentDate = new Date()
    const firstDayOfMonthDate = startOfMonth(currentDate);
    
    const [carregar, setCarregar] = useState(false);
    const [data, setData]   = useState([]);
    const [empresa, setEmpresa] = useState({value: '', text: ''});
    const [dateSCDe, setDateSCDe] = useState(format(firstDayOfMonthDate, 'yyyy-MM-dd'));
    const [dateSCAte, setDateSCAte] = useState(format(currentDate, 'yyyy-MM-dd'));
    const [dateDe, setDateDe] = useState();
    const [dateAte, setDateAte] = useState();
    const [campoSolicitacao, setCampoSolicitacao] = useState();
    const [campoPedidoCompra, setCampoPedidoCompra] = useState();
    const [campoNotaFiscal, setCampoNotaFiscal] = useState();
	const [campoProduto, setCampoProduto] = useState();
	const [campoCentroCusto, setCampoCentroCusto] = useState(null);
    const [campoStatus, setCampoStatus] = useState(null);
    const [campoPrioridade, setCampoPrioridade] = useState(null);
    const [campoStatusSC, setCampoStatusSC] = useState(null);
    const [campoStatusNF, setCampoStatusNF] = useState(null);

	const optionsSC = optionsStatusSC
	const options = optionsStatusPC
    const optionsPrio = [
        {
            value: '1',
            text: "Normal",
        },
        {
            value: '2',
            text: "Regularização",
        },
        {
            value: '3',
            text: "Emergencial",
        },
        {
            value: '5',
            text: "Reposição",
        },
        {
            value: '6',
            text: "Compra Direta",
        }
    ];
	const optionsNF = [
        {
            value: '0',
            text: "Todos",
            filtroSQL: "( 1 = 1 )"
        },
        {
            value: '1',
            text: "Rejeitado",
            filtroSQL: "( F1_STATUS = 'R' )"
        },
        {
            value: '2',
            text: "Em Aprovação",
            filtroSQL: "( F1_STATUS = 'B' AND F1_APROV = '" + window._env_?.REACT_APP_APROVA_NF + "' )"
        },
        {
            value: '5',
            text: "Bloqueado por Tolerância",
            filtroSQL: "( F1_STATUS = 'B' AND F1_APROV != '" + window._env_?.REACT_APP_APROVA_NF + "' )"
        },
        {
            value: '3',
            text: "Pré Nota",
            filtroSQL: "( F1_STATUS = '' AND D1_TES = '' )"
        },
        {
            value: '4',
            text: "Nota Fiscal Classificada",
            filtroSQL: "( F1_STATUS NOT IN ('R','B') AND D1_TES != '' )"
        },

    ]

    const excelColumns = [
        {
          Header: 'Filial',
          accessor: "C1_FILIAL",          
        },
        {
          Header: 'SC',
          accessor: "C1_NUM",          
        },
        {
          Header: 'Item',
          accessor: "C1_ITEM",          
        },
        {
          Header: 'Produto',
          accessor: "C1_PRODUTO",          
        },
        {
          Header: 'Descrição',
          accessor: "B1_DESC",          
        },
        {
          Header: 'CA',
          accessor: "C1_XCA",          
        },
        {
          Header: 'Descrição Complementar',
          accessor: "C1_OBS",          
        },
        {
          Header: 'Emissão SC',
          accessor: "C1_EMISSAO",          
          Cell: handleData
        },
        {
          Header: 'Aprovação',
          accessor: 'C1_XDTAPRV',
          Cell: handleData,
        },
        {
          Header: 'Prioridade',
          accessor: 'C1_XFLUXSC',
          Cell: handlePrioridadeSCColumn
        },
        {
          Header: 'Tipo de Compra',
          accessor: 'DHK_DESCR',
        },
        {
          Header: 'Solicitante',
          accessor: "C1_SOLICIT",          
        },
        {
          Header: 'Centro Custo',
          accessor: "C1_CC",          
        },
        {
          Header: 'Descrição Centro Custo',
          accessor: "CTT_DESC01",          
        },
        {
          Header: 'Conta Contábil',
          accessor: "C1_CONTA",          
        },
        {
          Header: 'Descrição Conta Contábil',
          accessor: "CT1_DESC01",          
        },
		{
          Header: 'Quantidade SC',
          accessor: 'C1_QUANT',
          Cell: (item) => formatarComoDecimal(item.value,4)
        },
        {
          Header: 'Preço Meta',
          accessor: 'C1_PRECO',
          Cell: (item) => formatarComoDecimal(item.value,4)
        },
        {
          Header: 'Total Meta',
          accessor: 'C1_TOTAL',
          Cell: (item) => formatarComoDecimal(item.value,2)
        },
        {
          Header: 'Status',
          accessor: '',
          Cell: handleStatusSC
        },
        {
          Header: 'Pedido',
          accessor: 'C7_NUM',
        },
        {
          Header: 'Item Pedido',
          accessor: 'C7_ITEM',
        },
        {
          Header: 'Quantidade Pedido',
          accessor: 'C7_QUANT',
          Cell: (item) => formatarComoDecimal(item.value,4)
        },
        {
          Header: 'Preço Pedido',
          accessor: 'C7_PRECO',
          Cell: (item) => formatarComoDecimal(item.value,4)
        },
        {
          Header: 'Total Pedido',
          accessor: 'C7_TOTAL',
          Cell: (item) => formatarComoDecimal(item.value,2)
        },
        {
          Header: 'Prioridade PC',
          accessor: 'C7_XFLUXSC',
          Cell: handlePrioridadeSCColumn
        },
        {
          Header: 'Emissão',
          accessor: 'C7_EMISSAO',
          Cell: handleData
        },
        {
          Header: 'Previsão',
          accessor: 'C7_DATPRF',
          Cell: handleData
        },
        {
          Header: 'Fornecedor',
          accessor: "C7_FORNECE",          
        },
        {
          Header: 'Loja Fornecedor',
          accessor: "C7_LOJA",          
        },
        {
          Header: 'Nome Fornecedor',
          accessor: "A2_NOME",          
        },
        {
          Header: 'Comprador',
          accessor: 'C7_COMPRA',
        },
        {
          Header: 'Nome Comprador',
          accessor: 'Y1_NOME',
        },
		{
          Header: 'CA Pedido',
          accessor: "C7_XCA",          
        },        
        {
          Header: 'Nota Fiscal',
          accessor: 'D1_DOC',
        },        
        {
          Header: 'Serie Nota',
          accessor: 'D1_SERIE',
        },        
        {
          Header: 'Emissão Nota',
          accessor: 'D1_EMISSAO',
          Cell: handleData
        },        
        {
          Header: 'Digitação Nota',
          accessor: 'D1_DTDIGIT',
          Cell: handleData
        },        
        {
          Header: 'Quantidade Nota',
          accessor: 'D1_QUANT',
          Cell: (item) => formatarComoDecimal(item.value,4)
        }
    ]

    // Colunas do grid
    const columns = [
        {
            Header: 'SC',
            accessor: "C1_NUM", 
            Cell: (item) => { 
                const { C1_FILIAL, C1_ITEM, C1_EMISSAO } = item.row.original;
                const emissao = handleData({value: C1_EMISSAO})

                return <>
                    <strong>Fil: </strong>{C1_FILIAL}
                    <br/><strong>SC: </strong>{item.value}/{C1_ITEM}
                    <br/><strong>Emissão: </strong>{emissao}
                </>
            }
        },
        {
            Header: 'Produto',
            accessor: "C1_PRODUTO",
            Cell: (item) => {
                const { C1_CC, CTT_DESC01, C1_PRODUTO, C1_XCA, C7_XCA, B1_DESC, C1_SOLICIT, C7_COMPRA, Y1_NOME } = item.row.original
                
                return <>
                    <CelBreak>{C1_PRODUTO.trim()} - {B1_DESC.trim()}{C1_XCA.trim() && ` - CA: ${C1_XCA}|${C7_XCA}`}</CelBreak>
					<CelBreak>
                        <strong>CC: {C1_CC.trim()}</strong> - {CTT_DESC01.trim()}
                    </CelBreak>
                    <CelBreak>
                        <strong>Solicitante: </strong>{C1_SOLICIT.trim()}
                    </CelBreak>
					<CelBreak>
                        <strong>Comprador: {C7_COMPRA}</strong> - {Y1_NOME.trim()}
                    </CelBreak>
                </>
            }
        },
        {
            Header: 'Pedido',
            accessor: "C7_NUM",
            Cell: (item) => { 
                const { C7_ITEM, C7_EMISSAO, C7_DATPRF } = item.row.original;
                const emissao = handleData({value: C7_EMISSAO})
                const previsao = handleData({value: C7_DATPRF})
                return <>
					{ item.value.trim() && (
						<>						
							<strong>PC: </strong>{item.value}/{C7_ITEM}                
							<br/><strong>Emissão: </strong>{emissao}
							<br/><strong>Previsão: </strong>{previsao}
                		</>
					)}
				</>
            }        
        },
        {
            Header: 'Preço / Total - PC',
            accessor: "C7_PRECO",  
            Cell: (item) => { 
                const { C7_QUANT, C7_TOTAL } = item.row.original;
                const qtd = formatarComoDecimal(C7_QUANT, 4)
                const unitario = formatarComoMoeda(item.value, 4)
                const total = formatarComoMoeda(C7_TOTAL)

                return <>                    
                    <strong>Qtde: </strong>{qtd}
                    <br/><strong>Unitário: </strong>{unitario}
                    <br/><strong>Total: </strong> {total}
                </>
            }        
        },
        {
            Header: 'Fornecedor',
            accessor: "C7_FORNECE",
            Cell: (item) => { 
                const { C7_LOJA, A2_NOME } = item.row.original;
                return <>
                    { item.value && (
						<CelBreak25>
							<strong>Fornecedor: {item.value.trim()}/{C7_LOJA}</strong> - {A2_NOME.trim()}
						</CelBreak25>
					)}
                </>
            }
        },
    ];

    // WHERE/filtros da consulta do grid
    const retornaConsultaDefault = () => {
        let consultaDefault = "SELECT C1_FILIAL, C1_NUM, C1_QUANT, C1_PRECO, C1_TOTAL, C1_ITEM, C1_EMISSAO, C1_SOLICIT, C1_CC, C1_CONTA, C1_XDTAPRV, DHK_DESCR, C1_XFLUXSC, C1_PRODUTO, B1_DESC, C1_XCA, C1_OBS, CTT_DESC01, CT1_DESC01, C7_XCA, C7_NUM, C7_ITEM, C7_XFLUXSC, C7_QUANT, C7_PRECO, C7_TOTAL, C7_FORNECE, C7_LOJA, C7_EMISSAO, C7_DATPRF, Y1_COD C7_COMPRA, Y1_NOME, A2_NOME, D1_DOC, D1_SERIE, D1_EMISSAO, D1_DTDIGIT, D1_QUANT, C1_QUJE, C1_COTACAO, C1_PEDIDO, C1_APROV, C1_RESIDUO, C1_FLAGGCT, C1_XMOTIV " + 
            "FROM TABELA(SC1) SC1 "+
            "INNER JOIN TABELA(CT1) CT1 ON CT1_FILIAL = FILIAL(CT1) AND CT1_CONTA = C1_CONTA AND CT1.D_E_L_E_T_ <> '*' " +
            "INNER JOIN TABELA(CTT) CTT ON CTT_FILIAL = FILIAL(CTT) AND CTT_CUSTO = C1_CC AND CTT.D_E_L_E_T_ <> '*' " +
            "INNER JOIN TABELA(SB1) SB1 ON B1_FILIAL = FILIAL(SB1) AND B1_COD = C1_PRODUTO AND SB1.D_E_L_E_T_ <> '*' " +
            "INNER JOIN TABELA(SY1) SY1 ON Y1_FILIAL = FILIAL(SY1) AND Y1_COD = C1_CODCOMP AND SY1.D_E_L_E_T_ <> '*' " + 
            "LEFT JOIN TABELA(PS1) PS1 ON PS1_FILIAL = FILIAL(PS1) AND PS1_NUM = C1_NUM AND PS1_ITEM = C1_ITEM AND PS1.D_E_L_E_T_ <> '*' " +
            "LEFT JOIN TABELA(SC7) SC7 ON C7_FILIAL = FILIAL(SC7) AND C7_NUMSC = C1_NUM AND C7_ITEMSC = C1_ITEM AND SC7.D_E_L_E_T_ <> '*' " +
            "LEFT JOIN TABELA(SC8) SC8 ON C8_FILIAL = FILIAL(SC8) AND C8_NUMSC = C1_NUM AND C8_ITEMSC = C1_ITEM AND C8_FORNECE = C7_FORNECE AND C8_LOJA = C7_LOJA AND C8_NUMPED = C7_NUM AND C8_ITEMPED = C7_ITEM AND SC8.D_E_L_E_T_ <> '*' " +
            "LEFT JOIN TABELA(SA2) SA2 ON A2_FILIAL = FILIAL(SA2) AND A2_COD = C7_FORNECE AND A2_LOJA = C7_LOJA AND SA2.D_E_L_E_T_ <> '*' " +
            "LEFT JOIN TABELA(SD1) SD1 ON D1_FILIAL = FILIAL(SD1) AND D1_PEDIDO = C7_NUM AND D1_ITEMPC = C7_ITEM AND SD1.D_E_L_E_T_ <> '*' " + 
            "LEFT JOIN TABELA(SF1) SF1 ON F1_FILIAL = FILIAL(SF1) AND F1_DOC = D1_DOC AND F1_SERIE = D1_SERIE AND F1_FORNECE = D1_FORNECE AND F1_LOJA = D1_LOJA AND SF1.D_E_L_E_T_ <> '*' " + 
            "LEFT JOIN TABELA(DHK) DHK ON DHK_FILIAL = FILIAL(DHK) AND DHK_CODIGO = C1_TIPCOM AND DHK.D_E_L_E_T_ <> '*' "
        let consultaFiltro = "WHERE SC1.D_E_L_E_T_ <> '*' ";
        
        consultaFiltro += "AND C1_FILIAL = FILIAL(SC1) ";
        
        if(dateSCDe) {
            consultaFiltro += "AND C1_EMISSAO >= '"+dateSCDe.replaceAll('-','')+"' ";
        }
        if(dateSCAte) {
            consultaFiltro += "AND C1_EMISSAO <= '"+dateSCAte.replaceAll('-','')+"' ";
        }
        if(dateDe) {
            consultaFiltro += "AND C7_EMISSAO >= '"+dateDe.replaceAll('-','')+"' ";
        }
        if(dateAte) {
            consultaFiltro += "AND C7_EMISSAO <= '"+dateAte.replaceAll('-','')+"' ";
        }
        if(campoSolicitacao) {
            consultaFiltro += "AND C1_NUMSC = '"+campoSolicitacao+"' ";
        }
        if(campoPedidoCompra) {
            consultaFiltro += "AND C7_NUM = '"+campoPedidoCompra+"' ";
        }
        if(campoNotaFiscal) {
            consultaFiltro += "AND C7_NUM = '"+campoNotaFiscal+"' ";
        }
		if(campoPrioridade?.value) {
            consultaFiltro += "AND C7_XFLUXSC = '"+campoPrioridade.value+"' ";
        }
		if(campoStatus?.filtroSQL) {
            consultaFiltro += "AND "+campoStatus.filtroSQL+" ";
        }
		if(campoStatusSC?.filtroSQL) {
            consultaFiltro += "AND "+campoStatusSC.filtroSQL+" ";
        }
		if(campoStatusNF?.filtroSQL) {
            consultaFiltro += "AND "+campoStatusNF.filtroSQL+" ";
        }
        if(campoProduto?.value) {
            consultaFiltro += "AND C7_PRODUTO = '"+campoProduto.value+"' ";
        }
        if(campoCentroCusto) {
            const filtroCC = campoCentroCusto.map((item) => item.value).join("','")
            if (filtroCC){
                consultaFiltro += "AND C1_CC IN ('"+filtroCC+"') ";
            }
        }
        
        consultaFiltro += " ORDER BY C7_EMISSAO DESC "

        return consultaDefault + consultaFiltro
    }

    // Processa consulta do grid
    const listaVendorList = async () => {
        var consultaDefault = retornaConsultaDefault();
        let empresaFilial = empresa.value ? empresa.value.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + empresa.value.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL) : ''

        setCarregar(true);
        var retConsulta = await ConsultaTotvsEmpresaIndividual( consultaDefault, "SC1;PS1;SC7;SC8;CTT;SA2;SY1;SB1;DHK;CT1;SD1;SF1", empresaFilial );
        
        if (retConsulta.error === '00'){
            setData(retConsulta.data);
        }

        setCarregar(false);
    }

    const excelHeaders = useMemo(() => {
        return excelColumns.map(col => col.Header);
    }, [excelColumns]);

    const excelRows = useMemo(() => {
        return data.map(item =>
            excelColumns.map(col => {
                const value = item[col.accessor];

                if (col.Cell) {
                    return col.Cell({ value, row: { original: item } });
                }
                return value ?? ""; // valor padrão se undefined/null
            })
        );
    }, [data, excelColumns]);

	const handleDocumento = () => {
        const value = campoNotaFiscal.trim() ? campoNotaFiscal.trim().padStart(9, '0'): "";
        
        setCampoNotaFiscal(value);
    }

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePage text="Vendor List"/>
                </Col>
                <Col md='4'>
                    <SelectEmpresa
                        campoEmpresa={empresa}
                        onChangeEmpresa={setEmpresa}
                    />
                </Col> 
                <Col md="8" xs="12">
                    <BuscaProduto 
                        empresaFilial={empresa.value.trim() || localStorage.getItem('empresaFilial')} 
                        handleProduto={(e) => { 
                            if (e) { 
                                setCampoProduto( { value: e.value, label: e.label } ); 
                                return 
                            } 
                            
                            setCampoProduto(); 
                        } } 
                        campoProduto={campoProduto}
                    />
                </Col>               
            </Row>
            <Row>
                <Col md="2" xs="12">
                    <InputGeral
                        label="Emissão SC De"
                        tipo='date'
                        value={dateSCDe}
                        onChange={(e) => setDateSCDe(e.target.value)}
                    />
                </Col>
                <Col md="2" xs="12">
                    <InputGeral
                        label="Emissão SC Até"
                        tipo='date'
                        value={dateSCAte}
                        onChange={(e) => setDateSCAte(e.target.value)}
                    />
                </Col>
				<Col md="2" xs="12">
                    <InputGeral 
                        label="Solicitação"
                        tipo='text'
                        max="6"
                        value={campoSolicitacao}  // Define o valor do campo com base no estado
                        onChange={(e) => setCampoSolicitacao(e.target.value)}
                    />
                </Col>
				<Col md="2" xs="12">
                    <SelectFixo 
                        options={optionsSC} 
                        value={campoStatusSC} 
                        selectedOptionValue={campoStatusSC}
                        isLabel={true} 
                        label="Status" 
                        onChange={(e) => setCampoStatusSC(e)}
                        />
                </Col>
				<Col md="4" xs="12">
                    <SelectCentroCusto 
                        campoCentroCusto={campoCentroCusto}
                        changeCentroCusto={setCampoCentroCusto}
                        empresaLogada={empresa.value}
						isMultiplo={true}
						filtraFilial={false}
                    />
                </Col>
            </Row>
            <Row>
				<Col md="2" xs="12">
                    <InputGeral
                        label="Emissão PC De"
                        tipo='date'
                        value={dateDe}
                        onChange={(e) => setDateDe(e.target.value)}
                    />
                </Col>
                <Col md="2" xs="12">
                    <InputGeral
                        label="Emissão PC Até"
                        tipo='date'
                        value={dateAte}
                        onChange={(e) => setDateAte(e.target.value)}
                    />
                </Col>  
                <Col md="2" xs="12">
                    <InputGeral 
                        label="Pedido"
                        tipo='text'
                        max="6"
                        value={campoPedidoCompra}  // Define o valor do campo com base no estado
                        onChange={(e) => setCampoPedidoCompra(e.target.value)}
                    />
                </Col>
                <Col md="3" xs="12">
                    <SelectFixo 
                        options={options} 
                        value={campoStatus} 
                        selectedOptionValue={campoStatus}
                        isLabel={true} 
                        label="Status Pedido" 
                        onChange={(e) => setCampoStatus(e)}
                    />
                </Col>
                <Col md="3" xs="12">
                    <SelectFixo
                        options={optionsPrio} 
                        value={campoPrioridade} 
                        selectedOptionValue={campoPrioridade} 
                        isLabel={true} 
                        label="Prioridade" 
                        onChange={setCampoPrioridade}
                    />
                </Col>
            </Row>
            <Row>
				<Col md="2" xs="12">
                    <InputGeral 
                        label="Nota Fiscal"
                        tipo='text'
                        max="6" 
                        value={campoNotaFiscal}  // Define o valor do campo com base no estado
                        onChange={(e) => setCampoNotaFiscal(e.target.value)}
						handleBlur={handleDocumento}
                    />
                </Col>
				<Col md="2" xs="12">
                    <SelectFixo 
                        options={optionsNF} 
                        value={campoStatusNF} 
                        selectedOptionValue={campoStatusNF}
                        isLabel={true} 
                        label="Status Nota" 
                        onChange={(e) => setCampoStatusNF(e)}
                    />
                </Col>
            </Row>
            <Row className="d-flex justify-content-end">
                <Col md="3" xs="12">
                    <Button variant="outline-primary" type="submit" className="w-100" onClick={listaVendorList}>
                        Buscar
                    </Button>
                </Col>
                <Col md="3" xs="12">
                    <ExportarExcel 
                        nomeArquivo="VendorList"
                        headers={excelHeaders}
                        rows={excelRows}
                    />
                </Col>
            </Row>
            
            <Row>
                <Col md="12" xs="12">
                    <ResponsiveDataTable 
                        columns={columns} 
                        data={data} 
                        buttons={[]}                        
                        paginacao={200}
                    />
                </Col>
            </Row>
        </>
    );
}

export default VendorList;
